import Organizations from "./Organizations";

export default Organizations;
